<template>
    <div class="plus-item">
        <button class="btn plus-button" @click.prevent="onAdd">
            <span class="button-wrapper">
                <svg class="plus-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M12 3.5V20.5" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M20.5 12H3.5" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span class="plus-text">{{ $t(`${text}`) }}</span>
            </span>
        </button>
    </div>
</template>

<script>
    export default {
        mixins: [

        ],
        props: {
            text: {
                type: String,
                default: 'global.add',
            }
        },
        data() {
            return {

            }
        },
        methods: {
            onAdd() {
                this.$emit('add');
            }
        }
    }
</script>

<style lang="scss" scoped>
.plus-item {
    display: block;
    width: 100%;
    height: 48px;

    .btn {
        color: var(--primary-color);
        box-shadow: 0 0 0 0 rgba(0, 0, 0, .2), 0 0 0 0 rgba(0, 0, 0, .14), 0 0 0 0 rgba(0, 0, 0, .12);
        border: 1px solid currentColor;
        border-color: rgba(0, 0, 0, .12);
        padding: 0 15px;
        margin: 0;
        display: flex;
        width: 100%;
        height: 100%;
        line-height: 44px;

        &:focus,
        &:hover {
            outline: 0;
            box-shadow: none;
            text-decoration: none;
        }

        .button-wrapper {
            display: flex;
            align-items: center;
            -ms-flex-align: center;

            svg {
                background-repeat: no-repeat;
                display: inline-block;
                fill: currentColor;
                height: 24px;
                width: 24px;
            }

            .plus-text {
                margin-left: 20px;
                font-weight: 500;
                font-size: 16px;
                line-height: 16px;
                text-transform: uppercase;
            }
        }
    }
}
</style>